export default function isLazyLoading(lazyLoadConfig) {
  if (typeof lazyLoadConfig === 'boolean') {
    return lazyLoadConfig;
  }

  if (!lazyLoadConfig) {
    return false;
  }

  var marginPercent = lazyLoadConfig.marginPercent;

  if (!marginPercent) {
    return true;
  }

  return marginPercent > -1;
}